<template>
    <div class="hue2-promo">
        <div class="container d-grid">
            <div class="v-hero--copy t-center">
                <h1 class="title t-upper t-white">
                    We got
                    <span class="title--emphasis">Hue</span>
                    <span class="title--last">covered</span>
                </h1>
                <p class="text t-white">
                    Purchase a HUE, receive a
                    <br>free HUE accessory on us.
                </p>
                <p
                    class="text text__small t-white"
                >*Discount applied automatically at checkout. Does not include refurbished builds.</p>
            </div>

            <div class="v-hero--cta t-center">
                <router-link to="/bld" class="btn btn-green hover-white m-y-md">GET STARTED</router-link>
            </div>
            <div class="v-hero--image">
                <img src="/images/Hue2-promo/HUE2-hero.png" alt="Hero-Case">
            </div>
        </div>
        <div class="row service-package" id="home-service">
            <div class="bld-features col-xs-12 p-a-0 m-y">
                <div class="service-details col-xs-12 col-md-3 text-center m-y">
                    <div class="img-container">
                        <img src="images/icons/build-ico.png" alt class="m-auto">
                    </div>
                    <div class="content">
                        <div class="text-white text-upper">
                            <h3 class="text-bold">
                                TAILORED FOR
                                <br>GAMES
                            </h3>
                        </div>
                        <div class="text text-white">
                            <p class="text-bold">
                                We’ve done the research and our algorithm takes care of the rest.
                            </p>
                        </div>
                    </div>
                    <router-link to="/what-is-bld" class="link-btn link-white">
                        LEARN MORE
                        <i class="fa fa-chevron-right" aria-hidden="true" />
                    </router-link>
                </div>
                <div class="service-details col-xs-12 col-md-3 text-center m-y">
                    <div class="img-container">
                        <img src="images/icons/glass.png" alt class="m-auto">
                    </div>
                    <div class="content">
                        <div class="text-white text-upper">
                            <h3 class="text-bold">
                                TRANSPARENT
                                <br>PRICING
                            </h3>
                        </div>
                        <div class="text text-white">
                            <p lass="text-bold">
                                Customize your build with our curated parts with straight forward pricing and a flat $99 assembly fee.
                            </p>
                        </div>
                    </div>
                    <router-link to="/what-is-bld" class="link-btn link-white">
                        LEARN MORE
                        <i class="fa fa-chevron-right" aria-hidden="true" />
                    </router-link>
                </div>
                <div class="service-details col-xs-12 col-md-3 text-center m-y">
                    <div class="img-container">
                        <img src="images/icons/2year-ico.png" alt class="m-auto">
                    </div>
                    <div class="content">
                        <div class="text-white text-upper">
                            <h3 class="text-bold">
                                All-in-One
                                <br>Warranty
                            </h3>
                        </div>
                        <div class="text text-white">
                            <p
                                class="text-bold"
                            >All components under one warranty plan – NZXT will manage any problems for you.</p>
                        </div>
                    </div>
                    <router-link to="/what-is-bld" class="link-btn link-white">
                        LEARN MORE
                        <i class="fa fa-chevron-right" aria-hidden="true" />
                    </router-link>
                </div>
                <div class="service-details col-xs-12 col-md-3 text-center m-y">
                    <div class="img-container">
                        <img src="images/icons/shipping-ico.png" alt class="m-auto">
                    </div>
                    <div class="content">
                        <div class="text-white text-upper">
                            <h3 class="text-bold">
                                48-Hour
                                <br>Turnaround
                            </h3>
                        </div>
                        <div class="text text-white">
                            <p class="text-bold">Get in the game quickly.</p>
                        </div>
                    </div>
                    <router-link to="/what-is-bld" class="link-btn link-white">
                        LEARN MORE
                        <i class="fa fa-chevron-right" aria-hidden="true" />
                    </router-link>
                </div>
            </div>
        </div>
        <!-- bld-intro-text -->
        <div class="row pos-r bg-black" id="what-is-bld">
            <a
                href="http://nzxt.com/"
                class="home-card bg-deep-purple bg-nzxt-section col-xs-12 col-md-6 p-a-0 pos-r"
                target="_blank"
            >
                <div class="section-content-holder p-y-md p-x m-auto text-white front">
                    <div class="content-title-holder">
                        <h2 class="text-upper">Cases, cooling &amp; accesories</h2>
                        <a href="http://nzxt.com/" class="link-btn link-white" target="_blank">
                            LEARN MORE
                            <i class="fa fa-chevron-right" />
                        </a>
                    </div>
                    <img src="/images/brand-logos/nzxt-bg-logo-w.png" alt>
                    <div class="clearfix"></div>
                </div>
                <div class="overlay-linear"></div>
            </a>
            <a
                href="https://camwebapp.com/"
                class="home-card bg-blue bg-cam-section col-xs-12 col-md-6 p-a-0 pos-r"
                target="_blank"
            >
                <div class="section-content-holder p-y-md p-x m-auto text-white front">
                    <div class="content-title-holder">
                        <h2 class="text-upper">Free app to monitor your PC</h2>
                        <a
                            href="https://camwebapp.com/"
                            class="link-btn link-white"
                            target="_blank"
                        >
                            DOWNLOAD NOW
                            <i class="fa fa-chevron-right" />
                        </a>
                    </div>
                    <img src="/images/brand-logos/cam-by-nzxt.png" alt>
                    <div class="clearfix"></div>
                </div>
                <div class="overlay-radial"></div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "Hue2Promo"
};
</script>

<style lang="scss" scoped>
// helppers
.pos-r,
.pos-front {
    position: relative;
}
.pos-front {
    z-index: 1;
}
.t-upper {
    text-transform: uppercase;
}
.t-white {
    color: #fff;
}
.t-center {
    text-align: center;
}
.shadow-inset {
    box-shadow: inset 0px 10px 50px -10px rgba(0, 0, 0, 0.75);
}
// grid
.d-grid {
    display: grid;
    grid-template-columns: 40% 57%;
    grid-template-rows: 90px 374px 173px 60px;
    grid-column-gap: 50px;
}
// buttons
.btn {
    font-size: 14px;
    padding: 12px 50px;

    &.btn-pink {
        background-color: #bf4cbf;
        display: inline-block;
        text-align: center;
        color: #fff;
        font-size: 14px;
        letter-spacing: 1.35px;
        border: none;
        border-radius: 4px;
        padding: 15px 63px;
        transition: all 0.4s ease;
        margin-top: 18px;

        &:hover {
            background-color: white;
            color: #bf4cbf;
        }
    }
}
// v's layout
.hue2-promo {
    overflow-x: hidden;
}
.v-hero {
    &__bg {
        background-color: #00000c;
        background-repeat: no-repeat;
        background-size: cover;
    }
    &__padder {
        padding: 20px 0;
    }
    &--copy {
        .title {
            font-size: 45px;
            letter-spacing: 6.4px;
            line-height: 54px;
            margin-bottom: 31px;

            &--emphasis {
                margin: 20px 0;
                display: block;
                letter-spacing: 1.66px;
                text-shadow: 0 2px 8px rgb(255, 0, 233);
                line-height: 67px;
                font-weight: bold;
                font-size: 100px;
                color: rgba(255, 255, 255, 0.47);
            }

            &--last {
                font-size: 42px;
                letter-spacing: 3.36px;
            }
        }

        .text {
            font-size: 18px;
            line-height: 24px;
            margin-bottom: 0;
            margin-top: 32px;

            &.text__small {
                font-size: 14px;
                width: 230px;
                margin: 10px auto 0;
                opacity: 0.7;
                line-height: 20px;
            }
        }
    }
}
// grid-styles
.v-hero {
    &--copy,
    &--cta {
        grid-column: 1;
    }
    &--copy {
        grid-row: 2;
    }
    &--cta {
        margin-top: 25px;
        grid-row: 3;
    }
    &--image {
        grid-column: 2;
        grid-row: 1 / span 4;
    }
}
.v-hero--image {
    img {
        max-width: 100%;
    }
}

@media screen and (max-width: 1200px) and (min-width: 320px) {
    // grid
    .d-grid {
        grid-template-columns: 50% 50%;
        grid-template-rows: 68px 215px 128px 20px;
        grid-column-gap: 0;
    }
    // v's layout
    .v-hero {
        &__padder {
            padding: 20px 0;
        }
        &--copy {
            margin-top: 30px;
            grid-row: 1 / span 2;
            .title {
                font-size: 35px;
                line-height: 45px;
                margin-bottom: 0;

                &--emphasis {
                    margin: 5px 0;
                    margin-right: 8px;
                    font-size: 80px;
                }

                &--last {
                    font-size: 36px;
                }
            }
            .text {
                font-size: 14px;
                letter-spacing: 0.06px;
                line-height: 20px;
                margin-top: 0px;

                &.text__small {
                    margin: 5px auto 0;
                    line-height: 17px;
                    width: 190px;
                    font-size: 12px;
                }
            }
        }
        &--cta {
            margin-top: 10px;
        }
        &--image {
            margin-top: -25px;
        }
    }

    .btn {
        &.btn-pink {
            margin-top: 30px;
        }
    }
}
@media screen and (max-width: 991px) and (min-width: 320px) {
    // grid
    .d-grid {
        grid-template-columns: 46% 54%;
        grid-template-rows: 50px 185px 128px 20px;
    }
    // v's layout
    .v-hero {
        &--copy {
            margin-top: 25px;
            .title {
                font-size: 30px;
                line-height: 40px;
                letter-spacing: 5px;

                &--emphasis {
                    margin: 2px 0;
                    margin-right: 3px;
                    font-size: 75px;
                    letter-spacing: 1px;
                }

                &--last {
                    font-size: 31px;
                }
            }
            .text {
                font-size: 13px;
                line-height: 19px;

                &.text__small {
                    font-size: 11px;
                }
            }
        }
        &--cta {
            margin-top: 40px;
        }
        &--image {
            margin-top: -10px;
        }
    }

    .btn {
        &.btn-pink {
            margin-top: 25px;
            padding: 12px 44px;
        }
    }
}
@media screen and (max-width: 767px) and (min-width: 320px) {
    // grid-styles
    .d-grid {
        grid-template-columns: 100%;
        grid-template-rows: auto;
    }
    .v-hero {
        &--copy,
        &--cta,
        &--image {
            grid-column: 1;
        }
        &--copy {
            grid-row: 1;
        }
        &--image {
            grid-row: 3;
        }
        &--cta {
            grid-row: 6;
            padding: 20px 0;
        }
    }
    .v-hero--cta {
        .btn {
            width: 75%;
        }
    }
    // v's layout
    .v-hero {
        &--copy {
            margin-top: 30px;
            .title {
                font-size: 32px;
                letter-spacing: 3.2px;
                line-height: 38px;
                margin-top: 30px;
                margin-bottom: 30px;

                &--emphasis {
                    margin: 3px 0;
                    margin-right: 3px;
                    font-size: 68px;
                    letter-spacing: 1.13px;
                }

                &--last {
                    font-size: 30px;
                    letter-spacing: 3px;
                }
            }
            .text {
                font-size: 15px;
                line-height: 19px;
                font-weight: normal;

                &.text__small {
                    margin-top: 10px;
                }
            }
        }
        &--cta {
            padding: 0px;
            margin: 10px 0 15px;
            grid-row: 2;
        }

        &--image {
            margin-bottom: 30px;
        }
    }

    .btn {
        &.btn-pink {
            padding: 15px 75px;
            width: auto;
        }
    }
}
</style>
